import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { Employee } from 'src/types/Employee';
import { EmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/EmployeeFormContext';

export interface EmployeeFormProviderProps {
  children: React.ReactNode;
  employeeData?: Employee;
}

export const EmployeeFormProvider: React.FC<EmployeeFormProviderProps> = ({
  children,
  employeeData,
}) => {
  const { employeeId } = useParams<{ employeeId?: string }>();
  const {
    enterpriseData: { isInternalAdminUser, isOnlyCorpAdminUser },
    corpData,
    corpId,
  } = useAuth();

  // Determine if we're in edit mode based on the URL parameter
  const isEditPage = Boolean(employeeId);

  const employeeFormContext = useMemo(
    () => ({
      isEditPage,
      corpId,
      corpData,
      employeeId,
      employeeData,
      isInternalAdminUser,
      isOnlyCorpAdminUser,
    }),
    [
      isEditPage,
      corpId,
      corpData,
      employeeId,
      employeeData,
      isInternalAdminUser,
      isOnlyCorpAdminUser,
    ]
  );

  return (
    <EmployeeFormContext.Provider value={employeeFormContext}>
      {children}
    </EmployeeFormContext.Provider>
  );
};
